import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledSignalUpsellBannerWrapper = styled(Flex)`
    box-sizing: border-box;
    align-items: center;
    width: 100%;
    padding: 20px 24px 16px 24px;
    border-radius: 6px;
    background: ${colorsPalettes.sky[100]};
`;

export const StyledSignalUpsellBannerContent = styled(Flex)`
    margin-left: 19px;
    width: 100%;
    justify-content: space-between;
`;

export const StyledSignalUpsellBannerTitle = styled.p`
    ${mixins.setFontVariant("subtitle1", colorsPalettes.indigo[300])};
    margin: 0 0 4px;
`;

export const StyledSignalUpsellBannerSubtitle = styled.p`
    ${mixins.setFontVariant("body2", colorsPalettes.indigo[300])};
    margin: 0;
`;

export const StyledSignalUpsellBannerButton = styled(Flex)`
    align-items: center;
`;
